import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../contexts/ThemeContext';

const AppearanceSwitch = ({ onChange } = {}) => {
  const { t } = useTranslation('profile');
  const { theme, toggleTheme } = useTheme();
  const isLight = theme === 'light';

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isLight}
      aria-label={t('appearance.lightMode', 'Light mode')}
      title={isLight ? t('appearance.switchToDark', 'Switch to dark mode') : t('appearance.switchToLight', 'Switch to light mode')}
      className="profile-appearance-switch"
      onClick={() => { toggleTheme(); onChange?.(isLight ? 'dark' : 'light'); }}
    >
      <i className={`fa-solid ${isLight ? 'fa-sun' : 'fa-moon'}`} aria-hidden="true" />
      <span>{isLight ? t('appearance.light', 'Light') : t('appearance.dark', 'Dark')}</span>
      <span className="profile-appearance-switch__track" aria-hidden="true">
        <span className="profile-appearance-switch__thumb" />
      </span>
    </button>
  );
};

export default AppearanceSwitch;
